<section class="ecb-x-admin-list-section">

  <div class="container-fluid">

    <div class="ecb-x-admin-list-card">

      <!-- Start Page Header -->
      <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
        <div>
          <h1 class="ecb-section-title">
            VOC Course Forms
          </h1>

          <p class="ecb-muted mb-0">
            Manage uploaded VOC forms, job numbers, course fees,
            payment status and reminders.
          </p>
        </div>
      </div>
      <!-- End Page Header -->

      <!-- Start VOC Table -->
      <p-table
    [value]="vocCourses"
    [loading]="isLoading"
    [scrollable]="true"
    [tableStyle]="{'min-width': '1280px'}"
    styleClass="ecb-admin-table">


        <!-- =================================================
       Header
  ================================================== -->

        <ng-template pTemplate="header">

          <tr class="ecb-admin-table-header-row">

            <th class="ecb-admin-table-header" style="width:70px;">
              ID
            </th>

            <th class="ecb-admin-table-header">
              Email
            </th>

            <th class="ecb-admin-table-header">
              Request Form
            </th>

            <th class="ecb-admin-table-header">
              Job Number
            </th>

            <th class="ecb-admin-table-header">
              Course Fee
            </th>

            <th class="ecb-admin-table-header">
              Payment Status
            </th>

            <th class="ecb-admin-table-header">
              Created Date
            </th>

            <th class="ecb-admin-table-header">
              Reminder
            </th>

            <th class="ecb-admin-table-header ecb-admin-table-action-header">
              Action
            </th>

          </tr>

        </ng-template>


        <!-- =================================================
       Body
  ================================================== -->

        <ng-template pTemplate="body" let-course>

          <tr class="ecb-admin-table-row">


            <!-- ID -->

            <td class="ecb-admin-table-cell">

              {{ course.id }}

            </td>


            <!-- Email -->

            <td class="ecb-admin-table-cell">

              <span class="ecb-voc-email-text">

                {{ course.clientEmail || '-' }}

              </span>

            </td>


            <!-- Request Form -->

            <td class="ecb-admin-table-cell">

              <a *ngIf="course.requestFormUrl" [href]="course.requestFormUrl" target="_blank" rel="noopener noreferrer"
                class="ecb-voc-form-link">

                <i class="fa fa-file-pdf-o"></i>

                View Form

              </a>


              <span *ngIf="!course.requestFormUrl">
                -
              </span>

            </td>


            <!-- Job Number -->

            <td class="ecb-admin-table-cell">

              <span class="ecb-voc-job-number" [class.ecb-voc-value-empty]="!course.jobNumber">

                {{ course.jobNumber || 'Not added' }}

              </span>

            </td>


            <!-- Course Fee -->

            <td class="ecb-admin-table-cell">

              <span *ngIf="hasCourseFee(course)" class="ecb-voc-course-fee">

                {{ course.courseFee | currency:'AUD':'symbol':'1.2-2' }}

              </span>


              <span *ngIf="!hasCourseFee(course)" class="ecb-voc-value-empty">

                Not added

              </span>

            </td>


            <!-- Payment Status -->

            <td class="ecb-admin-table-cell">

              <span class="ecb-payment-status" [ngClass]="{
            'ecb-payment-paid':
              course.paymentStatus?.toLowerCase() === 'paid',

            'ecb-payment-pending':
              !course.paymentStatus ||
              course.paymentStatus?.toLowerCase() === 'pending',

            'ecb-payment-failed':
              course.paymentStatus?.toLowerCase() === 'failed'
          }">

                {{ course.paymentStatus || 'Pending' }}

              </span>

            </td>


            <!-- Created Date -->

            <td class="ecb-admin-table-cell">

              {{
              course.createdDate
              ? (course.createdDate | date:'dd/MM/yyyy hh:mm a')
              : '-'
              }}

            </td>


            <!-- Reminder -->

            <td class="ecb-admin-table-cell">

              <span class="ecb-reminder-status" [ngClass]="
            course.isReminderSend
              ? 'ecb-reminder-sent'
              : 'ecb-reminder-not-sent'
          ">

                <i class="fa" [ngClass]="
              course.isReminderSend
                ? 'fa-check-circle'
                : 'fa-clock-o'
            ">
                </i>

                {{ course.isReminderSend ? 'Sent' : 'Not Sent' }}

              </span>

            </td>


            <!-- Action -->

            <td class="ecb-admin-table-cell ecb-admin-table-action-cell">

              <button *ngIf="course.paymentStatus?.toLowerCase() != 'paid'" type="button"
                class="ecb-admin-table-action-button ecb-admin-table-edit-button" (click)="openJobNumberDialog(course)"
                title="Add or edit details">

                <i class="fa fa-pencil ecb-admin-table-action-icon" aria-hidden="true">
                </i>

              </button>

            </td>

          </tr>

        </ng-template>


        <!-- =================================================
       Empty Message
  ================================================== -->

        <ng-template pTemplate="emptymessage">

          <tr class="ecb-admin-table-row">

            <td colspan="9" class="ecb-admin-table-cell">

              <div class="text-center py-5 ecb-muted">

                <i class="fa fa-folder-open-o ecb-empty-icon"></i>

                <div>
                  No VOC course forms found.
                </div>

              </div>

            </td>

          </tr>

        </ng-template>

      </p-table>
      <!-- End VOC Table -->

<!-- Start VOC Table Footer -->
<div class="ecb-x-admin-voc-table-footer">

    <div class="row align-items-center gy-3">

        <!-- Showing Records -->
        <div class="col-12 col-lg-4">

            <div class="ecb-x-admin-voc-paginator-info">

                Showing
                {{ startRecord }}–{{ endRecord }}
                of {{ totalRecords }} records

            </div>

        </div>


        <!-- Rows Per Page -->
        <div class="col-12 col-lg-4">

            <div class="ecb-x-admin-voc-paginator-size">

                <label>
                    Rows per page
                </label>

                <select
                    class="form-select form-select-sm"
                    [(ngModel)]="pageSize"
                    [disabled]="isLoading"
                    (ngModelChange)="onPageSizeChange()">

                    <option [ngValue]="10">10</option>
                    <option [ngValue]="20">20</option>
                    <option [ngValue]="50">50</option>
                    <option [ngValue]="100">100</option>

                </select>

            </div>

        </div>


        <!-- Page Navigation -->
        <div class="col-12 col-lg-4">

            <div class="ecb-x-admin-voc-paginator-navigation">

                <!-- Previous -->
                <button
                    type="button"
                    class="ecb-x-admin-voc-page-button"
                    [disabled]="pageNo === 1 || isLoading"
                    (click)="previousPage()">

                    Previous

                </button>


                <!-- Page Numbers -->
                <button
                    type="button"
                    *ngFor="let page of pageNumbers"
                    class="ecb-x-admin-voc-page-button"
                    [class.ecb-x-admin-voc-page-active]="pageNo === page"
                    [disabled]="isLoading"
                    [attr.aria-current]="pageNo === page ? 'page' : null"
                    (click)="changePage(page)">

                    {{ page }}

                </button>


                <!-- Next -->
                <button
                    type="button"
                    class="ecb-x-admin-voc-page-button"
                    [disabled]="pageNo === totalPages || isLoading"
                    (click)="nextPage()">

                    Next

                </button>

            </div>

        </div>

    </div>

</div>
<!-- End VOC Table Footer -->

      <!-- Start Success Message -->
      <div *ngIf="successMessage" class="alert alert-success mt-3 mb-0">

        <i class="fa fa-check-circle me-2"></i>

        {{ successMessage }}
      </div>
      <!-- End Success Message -->

      <!-- Start Error Message -->
      <div *ngIf="errorMessage && !showJobNumberDialog" class="alert alert-danger mt-3 mb-0">

        <i class="fa fa-exclamation-circle me-2"></i>

        {{ errorMessage }}
      </div>
      <!-- End Error Message -->

    </div>
  </div>
</section>

<!-- Start Add/Edit VOC Details Dialog -->
<p-dialog [(visible)]="showJobNumberDialog" [modal]="true" [draggable]="false" [resizable]="false"
  [closable]="!isSavingJobNumber" [closeOnEscape]="!isSavingJobNumber" [dismissableMask]="false" [style]="{
    width: '1000px',
    maxWidth: '96vw'
  }" styleClass="ecb-voc-job-dialog" (onHide)="onDialogHide()">

  <!-- Start Dialog Header -->
  <ng-template pTemplate="header">
    <div class="ecb-voc-dialog-header">

      <div class="ecb-voc-dialog-header-icon">
        <i class="fa fa-briefcase"></i>
      </div>

      <div>
        <h3>
          {{
          selectedCourse?.jobNumber
          ? 'Edit VOC Course Details'
          : 'Add VOC Course Details'
          }}
        </h3>

        <p>
          Add the job number and course fee before sending the payment email.
        </p>
      </div>

    </div>
  </ng-template>
  <!-- End Dialog Header -->

  <!-- Start Dialog Content -->
  <div *ngIf="selectedCourse" class="ecb-voc-dialog-content">

    <div class="row g-4">

      <!-- Start Details Form -->
      <div class="col-12 col-lg-4">

        <div class="ecb-voc-dialog-form-section">

          <h5 class="ecb-voc-dialog-section-title">
            <i class="fa fa-list-alt"></i>
            VOC Details
          </h5>

          <!-- Job Number -->
          <div class="mb-3">
            <label for="vocJobNumber" class="form-label ecb-voc-dialog-label">

              Job Number
              <span class="ecb-required">*</span>
            </label>

            <input id="vocJobNumber" type="text" class="form-control ecb-job-number-input" [(ngModel)]="jobNumberValue"
              name="vocJobNumber" maxlength="100" placeholder="Enter job number">

            <small class="ecb-input-help">
              Enter the job number assigned to this VOC request.
            </small>
          </div>

          <!-- Course Fee -->
          <div class="mb-4">
            <label for="vocCourseFee" class="form-label ecb-voc-dialog-label">

              Course Fee
              <span class="ecb-required">*</span>
            </label>

            <div class="input-group ecb-course-fee-group">

              <span class="input-group-text">
                AUD $
              </span>

              <input id="vocCourseFee" type="number" class="form-control ecb-course-fee-input"
                [(ngModel)]="courseFeeValue" name="vocCourseFee" min="0" step="0.01" placeholder="0.00">

            </div>

            <small class="ecb-input-help">
              Enter the total amount the client must pay.
            </small>
          </div>

          <!-- Request Details -->
          <div class="ecb-voc-dialog-information">

            <div class="ecb-voc-dialog-detail-item">
              <span>
                Request ID
              </span>

              <strong>
                #REQ-00{{ selectedCourse.id }}
              </strong>
            </div>

            <div class="ecb-voc-dialog-detail-item">
              <span>
                Client / Organisation Email
              </span>

              <strong>
                {{ selectedCourse.clientEmail || '-' }}
              </strong>
            </div>

            <div class="ecb-voc-dialog-detail-item">
              <span>
                Payment Status
              </span>

              <span class="ecb-payment-status" [ngClass]="{
                  'ecb-payment-paid':
                    selectedCourse.paymentStatus?.toLowerCase() === 'paid',

                  'ecb-payment-pending':
                    !selectedCourse.paymentStatus ||
                    selectedCourse.paymentStatus?.toLowerCase() === 'pending',

                  'ecb-payment-failed':
                    selectedCourse.paymentStatus?.toLowerCase() === 'failed'
                }">

                {{ selectedCourse.paymentStatus || 'Pending' }}
              </span>
            </div>

            <div class="ecb-voc-dialog-detail-item">
              <span>
                Created Date
              </span>

              <strong>
                {{
                selectedCourse.createdDate
                ? (selectedCourse.createdDate |
                date:'dd/MM/yyyy hh:mm a')
                : '-'
                }}
              </strong>
            </div>

          </div>

          <!-- Uploaded Form Link -->
          <a *ngIf="selectedCourse.requestFormUrl" [href]="selectedCourse.requestFormUrl" target="_blank"
            rel="noopener noreferrer" class="ecb-voc-dialog-pdf-link">

            <i class="fa fa-file-pdf-o"></i>

            View Uploaded VOC Form
          </a>

        </div>

      </div>
      <!-- End Details Form -->

      <!-- Start Email Preview -->
      <div class="col-12 col-lg-8">

        <div class="ecb-voc-email-preview-wrapper">

          <!-- Preview Toolbar -->
          <div class="ecb-voc-email-preview-toolbar">

            <div>
              <span class="ecb-voc-email-preview-label">
                Payment Email Preview
              </span>

              <small>
                Preview of the email content containing the payment link.
              </small>
            </div>

            <span class="ecb-voc-preview-badge">
              Preview
            </span>

          </div>

          <!-- Preview Email -->
          <div class="ecb-voc-email-preview">

            <!-- Email Header -->
            <div class="ecb-voc-email-header">

              <span class="ecb-voc-email-tag">
                VERIFICATION OF COMPETENCY
              </span>

              <h2>
                VOC Payment Request
              </h2>

              <p>
                Payment is required to continue processing the VOC course request.
              </p>

            </div>

            <!-- Email Body -->
            <div class="ecb-voc-email-body">

              <p class="ecb-voc-email-greeting">
                Hello,
              </p>

              <p>
                Your Verification of Competency request has been reviewed.
                Please find the assigned job number and course fee below.
              </p>

              <!-- Email Details -->
              <div class="ecb-voc-email-details">

                <div>
                  <span>
                    Request ID
                  </span>

                  <strong>
                    #REQ-00{{ selectedCourse.id }}
                  </strong>
                </div>

                <div>
                  <span>
                    Client / Organisation Email
                  </span>

                  <strong>
                    {{ selectedCourse.clientEmail || '-' }}
                  </strong>
                </div>

                <div>
                  <span>
                    Job Number
                  </span>

                  <strong class="ecb-voc-preview-job-number">
                    {{ jobNumberValue.trim() || 'JOB NUMBER' }}
                  </strong>
                </div>

                <div>
                  <span>
                    Course Fee
                  </span>

                  <strong class="ecb-voc-preview-course-fee">
                    {{
                    courseFeeValue !== null &&
                    courseFeeValue !== undefined
                    ? (courseFeeValue |
                    currency:'AUD':'symbol':'1.2-2')
                    : 'COURSE FEE'
                    }}
                  </strong>
                </div>

                <div>
                  <span>
                    Payment Status
                  </span>

                  <strong class="ecb-voc-preview-payment-status">
                    {{ selectedCourse.paymentStatus || 'Pending' }}
                  </strong>
                </div>

              </div>

              <!-- Information Notice -->
              <div class="ecb-voc-email-notice">

                <i class="fa fa-info-circle"></i>

                <span>
                  Please click the payment button below to complete your
                  payment securely. Processing will continue after the
                  payment is confirmed.
                </span>

              </div>

              <!-- Payment Button -->
              <div class="ecb-voc-email-button-section">

                <a *ngIf="selectedCourse.paymentUrl" [href]="selectedCourse.paymentUrl" target="_blank"
                  rel="noopener noreferrer" class="ecb-voc-preview-payment-button">

                  <i class="fa fa-credit-card"></i>

                  Click Here to Make Payment
                </a>

                <span *ngIf="!selectedCourse.paymentUrl" class="ecb-voc-preview-payment-button
                         ecb-voc-preview-payment-button-disabled">

                  <i class="fa fa-credit-card"></i>

                  Click Here to Make Payment
                </span>

              </div>

              <!-- PDF Link -->
              <div *ngIf="selectedCourse.requestFormUrl" class="ecb-voc-email-pdf-section">

                <a [href]="selectedCourse.requestFormUrl" target="_blank" rel="noopener noreferrer">

                  <i class="fa fa-file-pdf-o"></i>

                  View Uploaded VOC Request Form
                </a>

              </div>

            </div>

            <!-- Email Footer -->
            <div class="ecb-voc-email-footer">

              <strong>
                ECB Training Services
              </strong>

              <span>
                This is an automated email regarding your VOC request.
              </span>

            </div>

          </div>

        </div>

      </div>
      <!-- End Email Preview -->

    </div>

    <!-- Dialog Error -->
    <div *ngIf="errorMessage" class="alert alert-danger mt-4 mb-0">

      <i class="fa fa-exclamation-circle me-2"></i>

      {{ errorMessage }}
    </div>

  </div>
  <!-- End Dialog Content -->

  <!-- Start Dialog Footer -->
  <ng-template pTemplate="footer">

    <div class="ecb-voc-dialog-footer">

      <button type="button" class="ecb-btn-outline" [disabled]="isSavingJobNumber" (click)="closeJobNumberDialog()">

        <i class="fa fa-times"></i>

        Cancel
      </button>

      <button type="button" class="ecb-btn-primary" [disabled]="
          isSavingJobNumber ||
          !jobNumberValue.trim() ||
          courseFeeValue === null ||
          courseFeeValue === undefined ||
          courseFeeValue < 0
        " (click)="saveJobNumber()">

        <i class="fa" [ngClass]="isSavingJobNumber
            ? 'fa-spinner fa-spin'
            : 'fa-check'">
        </i>

        {{
        isSavingJobNumber
        ? 'Saving...'
        : 'Save Details'
        }}
      </button>

    </div>

  </ng-template>
  <!-- End Dialog Footer -->

</p-dialog>
<!-- End Add/Edit VOC Details Dialog -->